import React from "react";
import { Box, Typography } from "@mui/material";

const DocumentConvertPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>
        文档转换
      </Typography>
      <Typography variant="body1">此页面正在开发中...</Typography>
    </Box>
  );
};

export default DocumentConvertPage;
